(function(){
  if(window.__bigroonCartDiscountReady) return;
  window.__bigroonCartDiscountReady = true;

  /*
   * Managed offer registry.
   * Only offers that actually exist in Shopify belong here.
   * Future deployments may add 2+1 / 3+2 offers with their own code and threshold.
   */
  var OFFER_REGISTRY = {
    'foot-drop-brace': {
      offers: [
        {
          threshold: 2,
          code: 'BIGROON1PLUS1',
          displayFreeUnit: true,
          labels: {
            en: 'Buy 1, Get 1 Free',
            nl: '1 + 1 Gratis',
            de: '1 + 1 Gratis',
            fr: '1 acheté, 1 offert'
          }
        }
      ],
      legacyCodes: ['BIGROON2PACK']
    }
  };

  var scheduled = false;
  var activeRequest = 0;
  var syncing = false;
  var lastAttemptSignature = '';

  function locale(){
    var lang = (document.documentElement.lang || 'en').toLowerCase().split('-')[0];
    return ['nl','de','fr','en'].indexOf(lang) > -1 ? lang : 'en';
  }

  function copy(){
    return {
      en:{regular:'Regular price',saving:'Your offer',save:'You save'},
      nl:{regular:'Normale prijs',saving:'Jouw actie',save:'Je bespaart'},
      de:{regular:'Regulärer Preis',saving:'Deine Aktion',save:'Du sparst'},
      fr:{regular:'Prix normal',saving:'Votre offre',save:'Vous économisez'}
    }[locale()];
  }

  function root(){
    return window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
  }

  function cartUrl(path){
    return root().replace(/\/$/,'') + path;
  }

  function formatMoney(cents,currency){
    var lang = document.documentElement.lang || 'en';
    try{
      return new Intl.NumberFormat(lang,{style:'currency',currency:currency || 'EUR'}).format((Number(cents)||0)/100);
    }catch(e){
      return ((Number(cents)||0)/100).toFixed(2) + ' ' + (currency || 'EUR');
    }
  }

  function ensureStyle(){
    if(document.getElementById('BigroonCartDiscountStyle')) return;
    var style = document.createElement('style');
    style.id = 'BigroonCartDiscountStyle';
    style.textContent =
      '#BigroonCartDrawer .bg-cart-discount-summary{margin:0 0 8px;padding:8px 10px;border:1px solid rgba(55,89,108,.16);border-radius:10px;background:#f6f8f9}'+
      '#BigroonCartDrawer .bg-cart-discount-row{display:flex;align-items:center;justify-content:space-between;gap:12px;font-size:12px;line-height:1.3}'+
      '#BigroonCartDrawer .bg-cart-discount-row+ .bg-cart-discount-row{margin-top:7px}'+
      '#BigroonCartDrawer .bg-cart-discount-row strong{white-space:nowrap}'+
      '#BigroonCartDrawer .bg-cart-discount-row--regular{color:#6f7d84}'+
      '#BigroonCartDrawer .bg-cart-discount-row--regular strong{color:#c62828;text-decoration:line-through;text-decoration-thickness:1.5px;text-decoration-color:#c62828;font-weight:700}'+
      '#BigroonCartDrawer .bg-cart-discount-row--saving{color:#17313e;font-weight:700}'+
      '#BigroonCartDrawer .bg-cart-discount-row--saving span{display:inline-flex;align-items:center;gap:6px}'+
      '#BigroonCartDrawer .bg-cart-discount-row--saving span:before{content:"✓";display:grid;place-items:center;width:18px;height:18px;border-radius:50%;background:#37596C;color:#fff;font-size:11px}'+
      '#BigroonCartDrawer .bg-cart-discount-row--saving strong{color:#37596C}'+
      '#BigroonCartDrawer .bg-cart-discount-row--saved{margin-top:5px!important;color:#37596C;font-size:11.5px;font-weight:800}';
    document.head.appendChild(style);
  }

  function managedCodes(){
    var out = [];
    Object.keys(OFFER_REGISTRY).forEach(function(handle){
      var cfg = OFFER_REGISTRY[handle] || {};
      (cfg.offers || []).forEach(function(offer){
        var code = String(offer.code || '').toUpperCase();
        if(code && out.indexOf(code) === -1) out.push(code);
      });
      (cfg.legacyCodes || []).forEach(function(code){
        code = String(code || '').toUpperCase();
        if(code && out.indexOf(code) === -1) out.push(code);
      });
    });
    return out;
  }

  var MANAGED_CODES = managedCodes();

  function quantityForHandle(cart,handle){
    if(!cart || !Array.isArray(cart.items)) return 0;
    return cart.items.reduce(function(total,item){
      return total + (String(item.handle || '') === handle ? Number(item.quantity || 0) : 0);
    },0);
  }

  function eligibleOffer(cart){
    var candidates = [];
    Object.keys(OFFER_REGISTRY).forEach(function(handle){
      var qty = quantityForHandle(cart,handle);
      var offers = (OFFER_REGISTRY[handle].offers || []).slice().sort(function(a,b){
        return Number(b.threshold || 0) - Number(a.threshold || 0);
      });
      for(var i=0;i<offers.length;i++){
        if(qty >= Number(offers[i].threshold || 0)){
          candidates.push({handle:handle,quantity:qty,offer:offers[i]});
          break;
        }
      }
    });
    if(!candidates.length) return null;
    candidates.sort(function(a,b){
      return Number(b.offer.threshold || 0) - Number(a.offer.threshold || 0);
    });
    return candidates[0];
  }

  function addCode(set,value){
    var code = String(value || '').trim();
    if(!code) return;
    var upper = code.toUpperCase();
    if(!set.some(function(x){return x.toUpperCase() === upper;})) set.push(code);
  }

  function appliedCodes(cart){
    var out = [];
    function inspect(app){
      if(!app) return;
      var type = String(app.type || app.discount_application && app.discount_application.type || '').toLowerCase();
      var title = app.title || app.code || app.discount_application && (app.discount_application.title || app.discount_application.code);
      if(type === 'discount_code' || title){
        var upper = String(title || '').toUpperCase();
        if(MANAGED_CODES.indexOf(upper) > -1 || type === 'discount_code') addCode(out,title);
      }
    }

    (cart && cart.cart_level_discount_applications || []).forEach(inspect);
    (cart && cart.discount_applications || []).forEach(inspect);

    (cart && cart.items || []).forEach(function(item){
      (item.line_level_discount_allocations || []).forEach(function(allocation){
        inspect(allocation.discount_application || allocation);
      });
      (item.discounts || []).forEach(inspect);
    });
    return out;
  }

  function managedAppliedCode(cart){
    var codes = appliedCodes(cart);
    for(var i=0;i<codes.length;i++){
      var upper = String(codes[i] || '').toUpperCase();
      if(MANAGED_CODES.indexOf(upper) > -1) return upper;
    }
    return '';
  }

  function nonManagedAppliedCodes(cart){
    return appliedCodes(cart).filter(function(code){
      return MANAGED_CODES.indexOf(String(code || '').toUpperCase()) === -1;
    });
  }

  function cartSignature(cart,desired){
    var parts = (cart && cart.items || []).map(function(item){
      return String(item.handle || '') + ':' + String(item.quantity || 0);
    }).sort();
    parts.push('managed=' + managedAppliedCode(cart));
    parts.push('desired=' + String(desired || ''));
    return parts.join('|');
  }

  async function updateDiscountCodes(codes){
    var response = await fetch(cartUrl('/cart/update.js'),{
      method:'POST',
      credentials:'same-origin',
      cache:'no-store',
      headers:{
        'Content-Type':'application/json',
        Accept:'application/json',
        'X-Requested-With':'XMLHttpRequest'
      },
      body:JSON.stringify({discount:codes.join(',')})
    });
    if(!response.ok) throw new Error('Discount sync failed');
    return response.json();
  }

  async function syncManagedOffer(cart){
    if(syncing) return {changed:false,cart:cart,offer:eligibleOffer(cart)};
    var match = eligibleOffer(cart);
    var desired = match && match.offer ? String(match.offer.code || '').toUpperCase() : '';
    var current = managedAppliedCode(cart);

    if(current === desired) return {changed:false,cart:cart,offer:match};

    var signature = cartSignature(cart,desired);
    if(signature === lastAttemptSignature) return {changed:false,cart:cart,offer:match};
    lastAttemptSignature = signature;

    var codes = nonManagedAppliedCodes(cart);
    if(desired) addCode(codes,desired);

    syncing = true;
    try{
      var updated = await updateDiscountCodes(codes);
      return {changed:true,cart:updated,offer:eligibleOffer(updated)};
    }catch(e){
      return {changed:false,cart:cart,offer:match};
    }finally{
      syncing = false;
    }
  }

  function offerLabel(match){
    if(!match || !match.offer) return '';
    var labels = match.offer.labels || {};
    return labels[locale()] || labels.en || '';
  }

  function managedDiscountAmount(cart,managedCode){
    var total = 0;
    var target = String(managedCode || '').toUpperCase();
    (cart && cart.items || []).forEach(function(item){
      (item.line_level_discount_allocations || []).forEach(function(allocation){
        var app = allocation.discount_application || {};
        var title = String(app.title || app.code || '').toUpperCase();
        if(title === target) total += Number(allocation.amount || allocation.amount_set && allocation.amount_set.presentment_money && allocation.amount_set.presentment_money.amount * 100 || 0);
      });
    });
    if(total > 0 && total < 1000 && String(total).indexOf('.') > -1) total = Math.round(total * 100);
    if(total <= 0 && target && Number(cart && cart.total_discount || 0) > 0) total = Number(cart.total_discount || 0);
    return Math.round(total);
  }


  function cartItemNode(key){
    var nodes = document.querySelectorAll('#BigroonCartDrawer [data-bg-cart-item]');
    for(var i=0;i<nodes.length;i++){
      if(String(nodes[i].getAttribute('data-bg-cart-key') || '') === String(key || '')) return nodes[i];
    }
    return null;
  }

  function lineDiscountDelta(item){
    return Math.max(0,Number(item && item.original_line_price || 0)-Number(item && item.final_line_price || 0));
  }

  function ensureOriginalPrice(stack,current){
    var original = stack && stack.querySelector('[data-bg-cart-original]');
    if(original) return original;
    if(!stack || !current) return null;
    original = document.createElement('s');
    original.className = 'bg-cart-item__compare';
    original.setAttribute('data-bg-cart-original','');
    stack.insertBefore(original,current);
    return original;
  }

  function renderManagedLinePresentation(cart){
    var currentCode = managedAppliedCode(cart);
    var match = eligibleOffer(cart);
    if(!currentCode || !match || !match.offer || !match.offer.displayFreeUnit) return;
    if(String(match.offer.code || '').toUpperCase() !== currentCode) return;

    var threshold = Number(match.offer.threshold || 0);
    var items = (cart && cart.items || []).filter(function(item){
      return String(item.handle || '') === String(match.handle || '');
    });
    var totalQty = items.reduce(function(total,item){ return total + Number(item.quantity || 0); },0);

    // Only redistribute the visual line prices when the offer consists of
    // exactly two separate one-unit cart lines. If Shopify consolidates the
    // same variant into quantity 2, the truthful bundle line-total remains.
    if(threshold !== 2 || totalQty !== 2 || items.length !== 2) return;
    if(items.some(function(item){ return Number(item.quantity || 0) !== 1; })) return;

    var discounted = items.slice().sort(function(a,b){
      return lineDiscountDelta(b)-lineDiscountDelta(a);
    })[0];
    if(!discounted || lineDiscountDelta(discounted) <= 0) return;

    var paid = items[0] === discounted ? items[1] : items[0];
    if(!paid) return;

    var groupTotal = items.reduce(function(total,item){
      return total + Number(item.final_line_price || 0);
    },0);
    if(groupTotal <= 0) return;

    var paidNode = cartItemNode(paid.key);
    var freeNode = cartItemNode(discounted.key);
    if(!paidNode || !freeNode) return;

    var paidStack = paidNode.querySelector('[data-bg-cart-price-stack]');
    var paidCurrent = paidNode.querySelector('[data-bg-cart-current]');
    if(paidStack && paidCurrent){
      var paidOriginal = paidStack.querySelector('[data-bg-cart-original]');
      var paidSaving = paidStack.querySelector('[data-bg-cart-saving]');
      if(paidOriginal) paidOriginal.hidden = true;
      if(paidSaving) paidSaving.hidden = true;
      paidCurrent.textContent = formatMoney(groupTotal,cart.currency);
      paidNode.setAttribute('data-bg-offer-display','paid');
    }

    var freeStack = freeNode.querySelector('[data-bg-cart-price-stack]');
    var freeCurrent = freeNode.querySelector('[data-bg-cart-current]');
    if(freeStack && freeCurrent){
      var freeOriginal = ensureOriginalPrice(freeStack,freeCurrent);
      var freeSaving = freeStack.querySelector('[data-bg-cart-saving]');
      var freeReference = Number(discounted.original_line_price || discounted.price || 0);
      if(freeOriginal && freeReference > 0){
        freeOriginal.hidden = false;
        freeOriginal.textContent = formatMoney(freeReference,cart.currency);
      }
      if(freeSaving) freeSaving.hidden = true;
      freeCurrent.textContent = formatMoney(0,cart.currency);
      freeNode.setAttribute('data-bg-offer-display','free');
    }
  }

  function renderSummary(cart){
    var drawer = document.getElementById('BigroonCartDrawer');
    if(!drawer) return;
    var footer = drawer.querySelector('.sb-cart-drawer__footer');
    var subtotal = footer && footer.querySelector('.sb-cart-subtotal');
    if(!footer || !subtotal) return;

    var old = footer.querySelector('[data-bg-cart-discount-summary]');
    if(old) old.remove();

    var currentCode = managedAppliedCode(cart);
    var match = eligibleOffer(cart);
    if(!currentCode || !match || String(match.offer.code || '').toUpperCase() !== currentCode) return;

    var discount = managedDiscountAmount(cart,currentCode);
    if(discount <= 0) return;

    ensureStyle();
    var strings = copy();
    var regular = Number(cart.original_total_price || 0);
    if(!regular) regular = Number(cart.total_price || 0) + discount;

    var wrap = document.createElement('div');
    wrap.className = 'bg-cart-discount-summary';
    wrap.setAttribute('data-bg-cart-discount-summary','');
    wrap.innerHTML =
      '<div class="bg-cart-discount-row bg-cart-discount-row--saving"><span>'+offerLabel(match)+'</span><strong>−'+formatMoney(discount,cart.currency)+'</strong></div>'+
      '<div class="bg-cart-discount-row bg-cart-discount-row--saved"><span>'+strings.save+'</span><strong>'+formatMoney(discount,cart.currency)+'</strong></div>';
    footer.insertBefore(wrap,subtotal);
  }

  async function refreshDrawerIfPossible(wasOpen){
    if(window.BigroonCart && typeof window.BigroonCart.refresh === 'function'){
      try{
        await window.BigroonCart.refresh();
        if(wasOpen && typeof window.BigroonCart.open === 'function') window.BigroonCart.open();
        return true;
      }catch(e){}
    }
    return false;
  }

  async function render(){
    scheduled = false;
    var drawer = document.getElementById('BigroonCartDrawer');
    if(!drawer) return;
    var wasOpen = !drawer.hidden;
    var requestId = ++activeRequest;

    try{
      var response = await fetch(cartUrl('/cart.js'),{
        credentials:'same-origin',
        cache:'no-store',
        headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'}
      });
      if(!response.ok) return;
      var cart = await response.json();
      if(requestId !== activeRequest) return;

      var synced = await syncManagedOffer(cart);
      if(synced.changed){
        var refreshed = await refreshDrawerIfPossible(wasOpen);
        if(refreshed){
          schedule();
          return;
        }
        cart = synced.cart || cart;
      }

      renderManagedLinePresentation(cart);
      renderSummary(cart);
    }catch(e){}
  }

  function schedule(){
    if(scheduled) return;
    scheduled = true;
    setTimeout(render,40);
  }

  function touchesDrawer(node){
    if(!node || node.nodeType !== 1) return false;
    if(node.id === 'BigroonCartDrawer') return true;
    return !!(node.querySelector && node.querySelector('#BigroonCartDrawer'));
  }

  function init(){
    schedule();
    var observer = new MutationObserver(function(mutations){
      for(var i=0;i<mutations.length;i++){
        var added = mutations[i].addedNodes || [];
        var removed = mutations[i].removedNodes || [];
        for(var j=0;j<added.length;j++) if(touchesDrawer(added[j])){schedule();return;}
        for(var k=0;k<removed.length;k++) if(touchesDrawer(removed[k])){schedule();return;}
      }
    });
    observer.observe(document.body,{childList:true,subtree:true});
    window.addEventListener('pageshow',schedule);
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();